export default __webpack_public_path__ + "static/media/think-markets-logo-black.fec58205.png";